import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const Calculator: React.FunctionComponent<Props> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M21.0405 22.9197C15.3206 22.9197 9.60059 22.9197 3.88064 22.9197C3.75848 22.8843 3.63518 22.8522 3.51428 22.8128C2.59222 22.513 2.00252 21.6907 2.00213 20.6883C2.00121 17.9103 2.0059 15.1322 2.0059 12.3542C2.0059 9.66467 2.00388 6.97513 2 4.28553C1.99951 3.94052 2.04252 3.60473 2.19372 3.29328C2.60843 2.43907 3.29775 2.00427 4.24508 2.00268C7.10476 1.99793 9.96444 2.00094 12.8241 2.00094C15.4456 2.00094 18.0671 1.9993 20.6887 2.00181C21.6915 2.00274 22.5127 2.59135 22.813 3.51401C22.8523 3.63491 22.8845 3.75816 22.9199 3.88031C22.9199 9.60026 22.9199 15.3203 22.9199 21.0402C22.874 21.0729 22.8873 21.1252 22.8769 21.1697C22.6845 21.9848 22.1976 22.5368 21.4046 22.8129C21.2853 22.8544 21.162 22.8844 21.0405 22.9197ZM17.458 12.0209C18.9146 12.0209 20.3711 12.0179 21.8276 12.0248C22.0027 12.0256 22.0568 11.987 22.0563 11.8019C22.0496 9.29722 22.0528 6.7925 22.0512 4.28777C22.0506 3.41735 21.5051 2.87032 20.6368 2.86978C18.1321 2.86814 15.6273 2.87114 13.1226 2.86514C12.9445 2.8647 12.8954 2.90798 12.8958 3.08963C12.9018 5.99592 12.9014 8.90226 12.8964 11.8085C12.8961 11.9757 12.9362 12.0258 13.1088 12.0249C14.5585 12.0179 16.0082 12.0209 17.458 12.0209ZM12.0212 7.45731C12.0212 6.00072 12.0189 4.54419 12.0244 3.08761C12.025 2.92807 11.9974 2.86454 11.817 2.86497C9.29864 2.87108 6.78027 2.86743 4.26189 2.8701C3.42733 2.87098 2.8719 3.41963 2.87076 4.24868C2.86726 6.77382 2.87114 9.29902 2.86563 11.8242C2.86524 11.9923 2.92206 12.0239 3.075 12.0237C5.98811 12.0198 8.90128 12.0192 11.8144 12.0248C11.9897 12.0251 12.0255 11.971 12.0248 11.8065C12.0185 10.3569 12.0211 8.90707 12.0212 7.45731ZM7.45763 12.8997C6.0011 12.8997 4.54452 12.902 3.088 12.8965C2.92856 12.8959 2.86486 12.9234 2.8653 13.1038C2.87141 15.6222 2.86781 18.1405 2.87043 20.6588C2.8713 21.4919 3.42116 22.0489 4.24923 22.0501C6.77437 22.0539 9.29951 22.0498 11.8247 22.0553C11.993 22.0557 12.0243 21.9985 12.0241 21.8458C12.0202 18.9327 12.0196 16.0196 12.0252 13.1065C12.0256 12.9311 11.9714 12.8954 11.8069 12.8962C10.3571 12.9023 8.90734 12.8997 7.45763 12.8997ZM12.9 17.4639C12.9 18.9136 12.9043 20.3633 12.895 21.813C12.8937 22.0154 12.9534 22.0564 13.1455 22.0559C15.6366 22.0493 18.1277 22.0522 20.6187 22.0512C21.5039 22.0508 22.0506 21.5093 22.0512 20.6301C22.0527 18.1255 22.0502 15.6207 22.0552 13.1161C22.0556 12.9522 22.0206 12.8957 21.8453 12.8961C18.9323 12.9013 16.0192 12.9015 13.1061 12.8958C12.9298 12.8955 12.8957 12.9512 12.8964 13.1148C12.9025 14.5644 12.9 16.0141 12.9 17.4639Z'
        fill='url(#paint0_linear_12280_28354)'
        stroke='url(#paint1_linear_12280_28354)'
        strokeWidth='0.8'
      />
      <path
        d='M17.6803 8.09897C17.1289 8.09897 16.5775 8.10055 16.0261 8.09837C15.6998 8.09706 15.5202 7.94341 15.5176 7.67148C15.5149 7.39328 15.7031 7.23144 16.036 7.23117C17.1456 7.23029 18.2553 7.23013 19.365 7.23133C19.6371 7.2316 19.8131 7.35583 19.8556 7.56947C19.9132 7.85941 19.7267 8.09286 19.4163 8.09646C18.8377 8.10307 18.2591 8.09837 17.6804 8.09837C17.6803 8.09853 17.6803 8.09875 17.6803 8.09897Z'
        fill='url(#paint2_linear_12280_28354)'
        stroke='url(#paint3_linear_12280_28354)'
        strokeWidth='0.8'
      />
      <path
        d='M6.05913 8.0982C5.86182 8.0982 5.66412 8.10579 5.46724 8.09629C5.22184 8.0845 5.06192 7.91279 5.05864 7.67585C5.05531 7.43285 5.22217 7.2435 5.47243 7.23678C5.85325 7.22663 6.23473 7.22657 6.6156 7.23624C6.76183 7.23995 6.79861 7.19203 6.79528 7.05219C6.7865 6.6849 6.78459 6.31702 6.79556 5.94984C6.80582 5.6069 7.10329 5.40118 7.3976 5.52416C7.59907 5.60832 7.67002 5.7778 7.67035 5.98472C7.67084 6.3454 7.67663 6.70624 7.66773 7.06671C7.66434 7.20365 7.71096 7.23848 7.84147 7.23553C8.19516 7.22751 8.54918 7.23133 8.90304 7.23324C9.21912 7.23498 9.40514 7.39889 9.40426 7.67006C9.40339 7.94248 9.2236 8.09793 8.89921 8.10033C8.55213 8.1029 8.20477 8.10939 7.85811 8.09727C7.6989 8.09171 7.66364 8.14804 7.66751 8.29563C7.67701 8.65609 7.67614 9.01704 7.66811 9.37756C7.66178 9.66297 7.48532 9.84451 7.23402 9.84614C6.97617 9.84789 6.79894 9.65991 6.79392 9.3626C6.78786 9.00203 6.78606 8.64108 6.79518 8.28062C6.79884 8.13641 6.75178 8.09007 6.61014 8.09837C6.42702 8.10912 6.24281 8.10098 6.05903 8.10098C6.05914 8.10017 6.05913 8.09918 6.05913 8.0982Z'
        fill='url(#paint4_linear_12280_28354)'
        stroke='url(#paint5_linear_12280_28354)'
        strokeWidth='0.8'
      />
      <path
        d='M8.97286 19.0259C8.96472 19.1809 8.87712 19.3225 8.70797 19.3973C8.53664 19.473 8.37322 19.4397 8.23834 19.3061C7.94333 19.0138 7.64574 18.7239 7.3594 18.4234C7.25935 18.3183 7.20281 18.3217 7.10478 18.4247C6.83263 18.7106 6.55011 18.9867 6.26901 19.264C6.04998 19.48 5.80938 19.4929 5.62222 19.3045C5.43227 19.1133 5.44395 18.8769 5.65988 18.6578C5.94174 18.3717 6.22355 18.0853 6.51262 17.8065C6.60158 17.7207 6.60933 17.6701 6.51578 17.5804C6.22589 17.3026 5.9442 17.0161 5.66201 16.7302C5.44504 16.5104 5.43183 16.2736 5.6202 16.0835C5.80851 15.8935 6.04774 15.9046 6.26732 16.1202C6.55388 16.4016 6.84 16.6837 7.11875 16.9727C7.20488 17.0621 7.25499 17.0684 7.34451 16.975C7.62249 16.6852 7.90927 16.4038 8.19539 16.122C8.41508 15.9055 8.65284 15.8931 8.84219 16.0821C9.03071 16.2704 9.01871 16.5107 8.80322 16.7296C8.52141 17.0158 8.23965 17.3023 7.94971 17.5801C7.85648 17.6695 7.86243 17.7196 7.95184 17.8058C8.24091 18.0846 8.52043 18.3732 8.80545 18.6562C8.90059 18.7507 8.97051 18.855 8.97286 19.0259Z'
        fill='url(#paint6_linear_12280_28354)'
        stroke='url(#paint7_linear_12280_28354)'
        strokeWidth='0.8'
      />
      <path
        d='M17.7113 15.9425C18.2423 15.9425 18.7733 15.9412 19.3043 15.9437C19.3919 15.9442 19.4835 15.9477 19.5662 15.973C19.7554 16.0309 19.8558 16.1673 19.8629 16.3666C19.87 16.5658 19.7597 16.733 19.5755 16.7883C19.4988 16.8114 19.4149 16.8194 19.3342 16.8195C18.2382 16.8215 17.1422 16.8217 16.0462 16.8203C15.7454 16.8199 15.5629 16.6935 15.5239 16.4676C15.4716 16.1646 15.6713 15.9464 16.0163 15.9437C16.5813 15.9393 17.1463 15.9425 17.7113 15.9425Z'
        fill='url(#paint8_linear_12280_28354)'
        stroke='url(#paint9_linear_12280_28354)'
        strokeWidth='0.8'
      />
      <path
        d='M17.7112 18.5597C18.2421 18.5596 18.7732 18.5584 19.3041 18.5609C19.3917 18.5613 19.4833 18.5649 19.566 18.5901C19.7553 18.6479 19.8557 18.7843 19.8629 18.9836C19.8701 19.1827 19.76 19.35 19.5757 19.4054C19.499 19.4285 19.4151 19.4366 19.3344 19.4367C18.2384 19.4387 17.1424 19.4388 16.0464 19.4375C15.7455 19.4371 15.563 19.3109 15.5239 19.085C15.4715 18.782 15.6712 18.5636 16.0161 18.5609C16.5811 18.5565 17.1461 18.5597 17.7112 18.5597Z'
        fill='url(#paint10_linear_12280_28354)'
        stroke='url(#paint11_linear_12280_28354)'
        strokeWidth='0.8'
      />
      <defs>
        <linearGradient
          id='paint0_linear_12280_28354'
          x1='6.33204'
          y1='3.42649'
          x2='15.8652'
          y2='22.5339'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint1_linear_12280_28354'
          x1='6.33204'
          y1='3.42649'
          x2='15.8652'
          y2='22.5339'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint2_linear_12280_28354'
          x1='16.418'
          y1='7.28976'
          x2='16.516'
          y2='8.27187'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint3_linear_12280_28354'
          x1='16.418'
          y1='7.28976'
          x2='16.516'
          y2='8.27187'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint4_linear_12280_28354'
          x1='5.95848'
          y1='5.78544'
          x2='7.94775'
          y2='9.76132'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint5_linear_12280_28354'
          x1='5.95848'
          y1='5.78544'
          x2='7.94775'
          y2='9.76132'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint6_linear_12280_28354'
          x1='6.21026'
          y1='16.1871'
          x2='7.80007'
          y2='19.3723'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint7_linear_12280_28354'
          x1='6.21026'
          y1='16.1871'
          x2='7.80007'
          y2='19.3723'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint8_linear_12280_28354'
          x1='16.4159'
          y1='16.0014'
          x2='16.5162'
          y2='16.9949'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint9_linear_12280_28354'
          x1='16.4159'
          y1='16.0014'
          x2='16.5162'
          y2='16.9949'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint10_linear_12280_28354'
          x1='16.4159'
          y1='18.6186'
          x2='16.5162'
          y2='19.612'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint11_linear_12280_28354'
          x1='16.4159'
          y1='18.6186'
          x2='16.5162'
          y2='19.612'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Calculator;
